import { useCallback } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { enqueueSnackbar } from 'notistack';

import { useInterfaceLanguage } from '@/shared/i18n';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { useScreenRecordModalStore } from './useScreenRecordModalStore';

export const useScreenRecordAction = () => {
  const { t } = useInterfaceLanguage();
  const { isMobile } = useDeviceType();
  const { open: openScreenRecordModal } = useScreenRecordModalStore();

  return useCallback(async (): Promise<boolean> => {
    if (isMobile) {
      MixpanelEvents.desktopRequiredStateShown();
      enqueueSnackbar(t('recordingModals.recorder.desktopOnly'), { variant: 'info' });
      return false;
    }

    openScreenRecordModal();
    return true;
  }, [isMobile, openScreenRecordModal, t]);
};
